import { Box } from 'components/elements'
import { TableItemRow, TableTd } from 'theme/globalStyleCss'
import { ShimmerCss, IconButtonCss } from './styles'
import { TextShimmer } from './text'

export const ImsVideoShimmer = () => {
  return (
    <TableItemRow>
      <TableTd align={'center'}>
        <Box css={{ ...ShimmerCss, ...IconButtonCss }}></Box>
      </TableTd>
      <TableTd align={'center'}>
        <TextShimmer css={{ m: 0 }} />
      </TableTd>
    </TableItemRow>
  )
}
